import DOM from '@/scripts/old/modules/jqueryDOM';

const SUBMIT_SELECTOR = '.js-filter-group__submit';
const SUBMIT_CLASS_ACTIVE = '_active';

function FilterGroup() {
  let submitHideTimeout = null;

  DOM.$document.on('click', '.js-filter-group__title', function toggle() {
    const $group = $(this).closest('.js-filter-group');
    const $body = $group.find('.js-filter-group__body');

    $body.animate({
      height: 'toggle',
    }, () => {
      $group.toggleClass('is-collapsed', $body.is(':hidden'));
    });
  });

  DOM.$document.on('input', '.js-filter-group', function showSubmit() {
    $(SUBMIT_SELECTOR).removeClass(SUBMIT_CLASS_ACTIVE);
    const $submit = $(this).find(SUBMIT_SELECTOR);
    $submit.addClass(SUBMIT_CLASS_ACTIVE);

    clearTimeout(submitHideTimeout);
    submitHideTimeout = setTimeout(() => {
      $submit.removeClass(SUBMIT_CLASS_ACTIVE);
    }, 3000);
  });
}

export default new FilterGroup();
